/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteProductFromSortiment$Params {

/**
 * UUID of the product sortiment entry (productSortimentId) to remove
 */
  prodSortId: string;
}

export function deleteProductFromSortiment(http: HttpClient, rootUrl: string, params: DeleteProductFromSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteProductFromSortiment.PATH, 'delete');
  if (params) {
    rb.path('prodSortId', params.prodSortId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteProductFromSortiment.PATH = '/sortiments/products/{prodSortId}';
